import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { setLenis } from "@/lib/scroll";
import HomePage from "@/pages/HomePage";
import MentionsLegales from "@/pages/MentionsLegales";
import { GrainOverlay, ScrollProgress, CursorGlow } from "@/components/site/Effects";
import { CookieConsent } from "@/components/site/CookieConsent";

const LenisProvider = ({ children }) => {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    setLenis(lenis);
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      setLenis(null);
    };
  }, []);
  return children;
};

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LenisProvider>
          <ScrollToTop />
          <GrainOverlay />
          <ScrollProgress />
          <CursorGlow />
          <CookieConsent />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
          </Routes>
        </LenisProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
